module.exports = __webpack_public_path__ + "static/media/image-576.7cceea74.jpg";